export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/08e0f7c00e1f-tooliconrouter.jpg',
  },
  title: 'What is the name of your broadband package?',
}
